export class UnorderedAnnotationResultsProcessor {
    process(message, applyItem, onOperationProcessed, onMessageProcessed) {
        for (const op of message.ops) {
            if (op === null || op === void 0 ? void 0 : op.items) {
                for (const item of op.items) {
                    applyItem(op, item);
                }
            }
            onOperationProcessed(op);
        }
        onMessageProcessed(message);
    }
}
//# sourceMappingURL=unordered-annotation-results-processor.js.map